/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { InvoiceLineItemResponse } from '../models/invoice-line-item-response';

/**
 * Invoice Line item APIs
 */
@Injectable({ providedIn: 'root' })
export class InvoiceLineItemService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getInvoiceLineItems()` */
  static readonly GetInvoiceLineItemsPath = '/api/v1/line-items/invoices/{id}';

  /**
   * fetch invoice line items.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceLineItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceLineItems$Response(
    params: {
      /**
       * The invoice id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<InvoiceLineItemResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      InvoiceLineItemService.GetInvoiceLineItemsPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<InvoiceLineItemResponse>;
        })
      );
  }

  /**
   * fetch invoice line items.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInvoiceLineItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceLineItems(
    params: {
      /**
       * The invoice id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<InvoiceLineItemResponse> {
    return this.getInvoiceLineItems$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<InvoiceLineItemResponse>
        ): InvoiceLineItemResponse => r.body
      )
    );
  }
}
